import { GetUptimeApiArg, GetUptimeApiResponse } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { web3Api } from 'store/queries';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchUptime },
  useFetchUptimeQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchUptime: build.query<GetUptimeApiResponse, GetUptimeApiArg>({
      queryFn: createNotifyingQueryFn(async params => {
        const api = MultiService.getService().getStatusGateway();

        const data = await api.getUptime(params);

        return {
          data,
        };
      }),
    }),
  }),
  overrideExisting: true,
});
